import { useMemo, useState } from 'react'

/**
 * Penyaring teks untuk sebuah tabel. Satu bentuk, dipakai semua layar.
 *
 * Sebelum ini pencarian cuma ada di TIGA layar — semuanya di Tenant Marketing. Tenant
 * Admin dan Smova Admin tidak punya satu pun, termasuk di tabel yang justru paling cepat
 * tumbuh: catatan aktivitas, jalur masuk, daftar tenant. Layar yang isinya bertambah tiap
 * hari tanpa cara mencari adalah layar yang berhenti dipakai begitu isinya banyak.
 *
 * DISARING DI KLIEN, dan itu ada batasnya. Rute-rute ini mengembalikan halaman pertama
 * dan tidak menerima parameter pencarian, jadi yang tersaring hanya yang SUDAH terambil.
 * Benar selama puluhan sampai ratusan baris; di atas itu penyaringnya harus pindah ke
 * server. Ditulis di sini supaya perpindahannya nanti tidak jadi kejutan.
 *
 * `ambil` mengembalikan nilai-nilai yang boleh dicari dari satu baris. Yang `null` dan
 * `undefined` dibuang, sisanya diperlakukan sebagai teks — angka pun ikut tercari, dan
 * itu disengaja: orang mencari chat_id dan ID akun dengan mengetiknya.
 */
export function useCari(data, ambil) {
  const [cari, setCari] = useState('')

  const hasil = useMemo(() => {
    const semua = Array.isArray(data) ? data : []
    const c = cari.trim().toLowerCase()
    if (!c) return semua
    return semua.filter((baris) =>
      (ambil(baris) || [])
        .filter((v) => v !== null && v !== undefined)
        .some((v) => String(v).toLowerCase().includes(c)),
    )
    // `ambil` sengaja TIDAK jadi dependensi: pemanggil menuliskannya inline, jadi
    // identitasnya berubah tiap render dan memasukkannya akan membuat useMemo
    // menghitung ulang setiap kali — persis yang ingin dihindari.
  }, [data, cari])   // eslint-disable-line react-hooks/exhaustive-deps

  return { cari, setCari, hasil }
}
